module.exports = __webpack_public_path__ + "static/media/tonight.791eaed8.mp3";